import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 26 32"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#5B57A2\" d=\"m0 6.965 3.895 6.927v4.225L.005 25.03 0 6.965Z\"></path><path fill=\"#D90751\" d=\"m14.956 11.371 3.65-2.225 7.47-.007-11.12 6.777V11.37Z\"></path><path fill=\"#FAB718\" d=\"m14.935 6.925.021 9.17-3.904-2.386V0l3.884 6.925Z\"></path><path fill=\"#ED6F26\" d=\"m26.076 9.139-7.47.007-3.67-2.221L11.051 0l15.024 9.139Z\"></path><path fill=\"#63B22F\" d=\"M14.956 25.068v-4.45l-3.904-2.34L11.054 32l3.902-6.932Z\"></path><path fill=\"#1487C9\" d=\"M18.597 22.863 3.895 13.892 0 6.965l26.06 15.889-7.464.009Z\"></path><path fill=\"#017F36\" d=\"m11.055 32 3.901-6.932 3.641-2.205 7.463-.01L11.055 32Z\"></path><path fill=\"#984995\" d=\"m.005 25.03 11.079-6.753-3.725-2.273-3.463 2.112L.005 25.03Z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h26v32H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }